const Solutions = [
  {
    title : "Example",
    // title: "💼 MetaLawyers – A True Revolution in Professional Legal Practice",
    content: `🔰 The First Fully Specialized, Comprehensive AI Platform for Licensed Attorneys Worldwide
What MetaLawyers offers is not merely technology—it is the birth of a new era of intelligent, doctrinally grounded, and strategy-driven legal advocacy. This world-first platform is engineered exclusively for practicing attorneys and has been launched—proudly—for the first time in the Islamic Republic of Iran.

No jurisdiction, no bar association, and no global legal institution has yet succeeded in building a platform with this scope, depth, and alignment with the real and evolving needs of legal practitioners.

✨ A Global Legal Breakthrough—Pioneered from Iran ✨`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙24",
  },
  {
    title : "Example1",
    // title: "Advanced AI Analysis of Party Submissions",
    content: `MetaLawyers analyzes pleadings from both plaintiff and defendant with precision exceeding any manual review. It decodes legal logic, identifies argumentative weaknesses, and exposes structural flaws—providing attorneys with critical litigation foresight.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙24",
  },
  {
    title : "Example2",
    // title: "Prompt-Centered Brief Interpretation",
    content: `For the first time in legal AI, attorneys can define their own prompt, and MetaLawyers will construct its analysis entirely around that custom query. This means the response is not just legally accurate—it is professionally aligned with the attorney’s exact thought process.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙24",
  },
  {
    title : "Example3",
    // title: "Structured, Evidence-Based Review of Judicial Rulings",
    content: `From final judgments to interim orders, MetaLawyers offers comprehensive rulings analysis grounded in national doctrine, relevant statutes, and prevailing case law—resembling the depth of a legal opinion from top-tier scholars.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙24",
  },
  {
    title : "Example4",
    // title: "Custom Judgment Analysis Based on Attorney’s Perspective",
    content: `Unlike traditional legal tools, MetaLawyers interprets a judgment from your lens. By inputting a custom prompt, the ruling is evaluated according to your litigation intent—whether for objection, appeal, or strategic defense.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example5",
    // title: "AI-Powered Legal Case & Client Management",
    content: `From hearing schedules to digital loya drafts, MetaLawyers brings together all aspects of legal case management under a single interface—designed exclusively for the real workflow of attorneys.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example6",
    // title: "Scholar-Based Legal Interpretation",
    content: `Attorneys may select a preferred legal thinker or doctrinal school—from Professor Katoozian to Hans Kelsen or Ronald Dworkin—and MetaLawyers will construct responses based on that academic framework.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example7",
    // title: "Strategic Path Selection by the Attorney",
    content: `MetaLawyers doesn’t dictate a single answer—it offers a spectrum of doctrinally valid responses. The attorney guides the analysis by choosing the reasoning path most suited to their litigation strategy.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example8",
    // title: "Editable Legal Drafts with PDF Export",
    content: `Generate clear, fully formatted, court-ready documents at the click of a button. Review, revise, and download your legal brief as a high-quality PDF, eliminating unnecessary formatting tasks.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example9",
    // title: "Doctrinal, Topic-Specific Legal Synthesis",
    content: `Responses are constructed based on core legal issues, enriched by doctrinal insight, formal guidance from the judiciary, and relevant precedent—providing multidimensional, jurisprudentially sound answers.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example11",
    // title: "Multilingual Legal Output",
    content: `MetaLawyers delivers professional-grade legal content in English, French, German, Spanish, and Russian—without sacrificing legal nuance, structure, or jurisdictional relevance.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example22",
    // title: "Specialized Capacity in Public International Law",
    content: `Analyze treaties, disputes, and cross-border conflicts with interpretations rooted in expert doctrines like Brownlie, Shaw, or Crawford—giving your international work the rigor it demands.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example33",
    // title: "International Criminal Law Capabilities",
    content: `MetaLawyers incorporates the latest jurisprudence from the International Criminal Court (ICC), the International Court of Justice (ICJ), and other tribunals—providing real-time insight into international criminal litigation frameworks.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example44",
    // title: "Real-Time Statutory Monitoring & Legal Updates",
    content: `All outputs are synchronized with the latest legal reforms, amendments, and official regulations. MetaLawyers ensures that your responses reflect the most current state of the law—no outdated clauses, no stale analysis.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙23",
  },
  {
    title : "Example55",
    // title: "Defensive Strategy Generator",
    content: `More than just analysis, MetaLawyers builds a strategic response plan for attorneys—recommending legal tactics, procedural defenses, and litigation strategies tailored to each case context.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙22",
  },
  {
    title : "Example66",
    // title: "Success Forecasting & Outcome Mapping",
    content: `MetaLawyers evaluates all inputs—documents, prompts, strategy—and delivers statistically backed success probabilities. It also maps a path forward, outlining the legal route most likely to yield favorable outcomes for the attorney.`,
    cat: "CATEGORY 1 > CATEGORY",
    num: "˙22",
  },
];

export default Solutions;
